import * as React from 'react';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { SpecialistKompetensYrken, Location, IYrkesValProps, IYrkesValState } from './YrkesVal.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';

let Translate: (key: string, defaultValue?: string) => string;
export class YrkesVal extends React.Component<IYrkesValProps, IYrkesValState> {
  constructor(props: IYrkesValProps) {
    super(props);

    this.state = {
      currentYrke: null,
      currentLocation: null,
    };

    Translate = makeTranslator(props.translations);
  }

  setActiveYrke = (value: FormField<SpecialistKompetensYrken>) => {
    this.setState({ currentYrke: value.value });
  };

  setActiveLocation = (value: FormField<Location>) => {
    this.setState({ currentLocation: value.value });
  };

  getYrkeTextAndPropertyName = (): [string, string] => {
    const { model } = this.props;
    const { currentYrke, currentLocation } = this.state;
    if (currentYrke === null || currentLocation === null) return ['', ''];
    const yrkeText = model[currentYrke][currentLocation];

    //property names are constructed using currentYrke+currentLocation pattern in the Episerver page.
    const propertyName = currentYrke + currentLocation;
    return [yrkeText, propertyName];
  };

  public render() {
    const { model, isEditMode } = this.props;
    const { currentYrke, currentLocation } = this.state;

    const [yrkeText, propertyName] = this.getYrkeTextAndPropertyName();
    const isSpecialistsjukskoterska = currentYrke === SpecialistKompetensYrken.Sjukskoterska;
    const isSjukhusfysiker = currentYrke === SpecialistKompetensYrken.Sjukhusfysiker;
    return (
      <>
        <div className="m-b-2">
          <EpiserverProperty isInEditMode={isEditMode} propertyName="PickYrkeHeader">
            <h2>{model.PickYrkeHeader}</h2>
          </EpiserverProperty>
          <RadioButtonGroup fieldName="pickyrke" onChange={this.setActiveYrke}>
            <RadioButton value={SpecialistKompetensYrken.Lakare} label={Translate('yrke/lakare')} />
            <RadioButton value={SpecialistKompetensYrken.Tandlakare} label={Translate('yrke/tandlakare')} />
            <RadioButton value={SpecialistKompetensYrken.Sjukskoterska} label={Translate('yrke/sjukskoterska')} />
            <RadioButton value={SpecialistKompetensYrken.Sjukhusfysiker} label={Translate('yrke/sjukhusfysiker')} />
          </RadioButtonGroup>
        </div>

        <div role="log" aria-live="polite">
          {!currentYrke && (
            <AttentionBox
              cssClass="attentionbox--brown"
              icon="Infocirkel_normal20px20px"
              heading={model.Warning.Title}
              bodytext={model.Warning.Text}
            />
          )}
        </div>
        <div role="log" aria-live="polite">
          {currentYrke && (
            <div className="m-b-2">
              <EpiserverProperty isInEditMode={isEditMode} propertyName="ChooseLocationHeader">
                <h2 className="inlineblock">{model.ChooseLocationHeader}</h2>
              </EpiserverProperty>
              {model.InfoBubble && (
                <div className="inlineblock">
                  <Tooltip text={model.InfoBubble} />
                </div>
              )}
              <RadioButtonGroup fieldName="picklocation" onChange={this.setActiveLocation}>
                <RadioButton value={Location.Swe} label={Translate('location/sverige')} />
                <RadioButton value={Location.Eu} label={Translate('location/eu')} />
                <RadioButton value={Location.NonEu} label={Translate('location/nonEu')} />
                {
                  <RadioButton
                    hidden={isSpecialistsjukskoterska || isSjukhusfysiker}
                    value={Location.NonEu3Year}
                    label={Translate('location/nonEu3Year')}
                  />
                }
              </RadioButtonGroup>
            </div>
          )}
        </div>

        <div role="log" aria-live="polite">
          {currentLocation && (
            <EpiserverProperty
              isInEditMode={isEditMode}
              propertyName={propertyName}
              usingDangerouslySetInnerHTML={true}>
              <div role="log" aria-atomic="false" dangerouslySetInnerHTML={setInnerHtml(yrkeText)}></div>
            </EpiserverProperty>
          )}
        </div>
      </>
    );
  }
}
